import type { BadgeTone } from '@/components/dashboard/StatusBadge';
import type { UnitAvailabilityStatus, UnitSummary } from '@/lib/types/property';
import { formatMoveInTimingLabel } from '@/lib/utils/propertyFormatting';

export function formatMoveInReadinessLabel(unit: UnitSummary): string {
  return formatMoveInTimingLabel(unit.availabilityStart, unit.possessionTimeline);
}

export function formatRent(unit: UnitSummary): string {
  const formatter = new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD',
    maximumFractionDigits: 2,
  });
  const suffix = 'SF Annual';
  const prefix = formatter.format(unit.rent.netRentPerSf);
  if (unit.rent.rentBasis === 'gross') {
    return `${prefix}/${suffix}`;
  }
  const addl =
    typeof unit.rent.additionalRentPerSf === 'number'
      ? ` + ${formatter.format(unit.rent.additionalRentPerSf)}/${suffix}`
      : '';
  return `${prefix}/${suffix}${addl}`;
}

export function readinessTone(status: UnitAvailabilityStatus): BadgeTone {
  switch (status) {
    case 'available':
      return 'success';
    case 'unavailable':
      return 'warning';
    default:
      return 'neutral';
  }
}
